import { render } from "./ExtensionPanel.vue?vue&type=template&id=738c2b23"
import script from "./ExtensionPanel.vue?vue&type=script&lang=js"
export * from "./ExtensionPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__